interface ErrorMessage {
  title: string;
  message: string;
}

export const ERROR_MESSAGES: Record<string | number, ErrorMessage> = {
  404: {
    title: '404 Page not found!!!',
    message: 'We could not find the page you are looking for. Please feel free to navigate to our other pages.',
  },
  500: {
    title: '500 Internal Server Error!!!',
    message:
      'We are sorry for our inconvenience, we will fix it as soon as possible. Meanwhile please feel free to navigate to our other pages.',
  },
  default: {
    title: 'Something went wrong!!! Please refresh page to try again',
    message:
      'We are sorry for our inconvenience, we will fix it as soon as possible. Meanwhile please feel free to navigate to our other pages.',
  },
};
